module.exports = __webpack_public_path__ + "img/CS-Profi-Repairing.0ec94715.jpg";